import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router} from '@angular/router';
import {PermissionsService} from '../Services/permissions.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionGuard implements CanActivate {

  constructor(
    private permissionsService: PermissionsService,
    private router: Router
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    // Admin users bypass all permission checks
    if (this.permissionsService.Get('Admin')) {
      return true;
    }

    // No permission key on the route — open to all authenticated users
    const permissionKey: string = route.data?.['permission'];
    if (!permissionKey) {
      return true;
    }

    // Check the specific View* permission key
    if (this.permissionsService.Get(permissionKey)) {
      return true;
    }

    // No permission — redirect to Not Authorized page
    this.router.navigate(['/common/not-authorized-page']).then();
    return false;
  }
}
